import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { AuthService } from "./auth.service";

export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);

  const user = await auth.getUser();

  if (user && !user.expired) {
    return true;
  }

  await auth.login();
  return false;
};
